if (!customElements.get('card-qty-buttons')) {
  customElements.define(
    'card-qty-buttons',
    class CardQtyButtons extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.qty = parseInt(this.dataset.cartQty, 10) || 0;
        this.display = this.querySelector('.quantity__display');
        this.minusBtn = this.querySelector('[name="minus"]');
        this.plusBtn = this.querySelector('[name="plus"]');
        this.busy = false;

        this.plusBtn.addEventListener('click', () => this.change(1));
        this.minusBtn.addEventListener('click', () => this.change(-1));
        this.updateUI();
      }

      connectedCallback() {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.cartData && event.cartData.items) {
              var found = event.cartData.items.find(
                (item) => String(item.variant_id) === String(this.variantId)
              );
              this.qty = found ? found.quantity : 0;
              this.updateUI();
            }
          });
        }
      }

      disconnectedCallback() {
        if (this._unsub) this._unsub();
      }

      updateUI() {
        this.display.textContent = this.qty;
        this.minusBtn.classList.toggle('disabled', this.qty <= 0);
      }

      change(delta) {
        if (this.busy) return;
        var newQty = Math.max(0, this.qty + delta);
        if (newQty === this.qty) return;

        this.busy = true;
        this.classList.add('card-qty-loading');

        if (this.qty === 0 && delta > 0) {
          this.addToCart(newQty);
        } else {
          this.updateCart(newQty);
        }
      }

      addToCart(qty) {
        var body = JSON.stringify({
          id: parseInt(this.variantId, 10),
          quantity: qty,
          sections: this.getSections(),
          sections_url: window.location.pathname,
        });

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: body,
        })
          .then((r) => r.json())
          .then((data) => {
            this.qty = qty;
            this.updateUI();
            this.refreshDrawer(data);
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'card-qty-buttons',
                productVariantId: this.variantId,
                cartData: data,
              });
            }
          })
          .catch(console.error)
          .finally(() => {
            this.busy = false;
            this.classList.remove('card-qty-loading');
          });
      }

      updateCart(newQty) {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            var lineIndex = -1;
            for (var i = 0; i < cart.items.length; i++) {
              if (String(cart.items[i].variant_id) === String(this.variantId)) {
                lineIndex = i + 1;
                break;
              }
            }
            if (lineIndex === -1) {
              if (newQty > 0) return this.addToCart(newQty);
              this.busy = false;
              this.classList.remove('card-qty-loading');
              return;
            }

            var body = JSON.stringify({
              line: lineIndex,
              quantity: newQty,
              sections: this.getSections(),
              sections_url: window.location.pathname,
            });

            return fetch(window.routes.cart_change_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: body,
            })
              .then((r) => r.json())
              .then((data) => {
                this.qty = newQty;
                this.updateUI();
                this.refreshDrawer(data);
                if (typeof publish === 'function') {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'card-qty-buttons',
                    productVariantId: this.variantId,
                    cartData: data,
                  });
                }
              });
          })
          .catch(console.error)
          .finally(() => {
            this.busy = false;
            this.classList.remove('card-qty-loading');
          });
      }

      getSections() {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) return drawer.getSectionsToRender().map((s) => s.id);
        return ['cart-icon-bubble'];
      }

      refreshDrawer(data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections) {
          drawer.getSectionsToRender().forEach((section) => {
            var el = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (el && data.sections[section.id]) {
              el.innerHTML = new DOMParser()
                .parseFromString(data.sections[section.id], 'text/html')
                .querySelector(section.selector || '.shopify-section').innerHTML;
            }
          });
          drawer.classList.toggle('is-empty', data.item_count === 0);
        }
        this.updateBubble(data);
      }

      updateBubble(data) {
        if (data.sections && data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            bubble.innerHTML = new DOMParser()
              .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }
        }
      }
    }
  );
}
